import { useEffect } from 'react';
import { locale } from 'moment';
import i18next from 'i18next';

const useMomentLocale = () => {
  useEffect(() => {
    const setMomentLocale = () => {
      locale(i18next.language ? i18next.language : 'en');
    };

    setMomentLocale();

    i18next.on('languageChanged', setMomentLocale);

    return () => {
      i18next.off('languageChanged', setMomentLocale);
    };
  }, []);
};

export default useMomentLocale;
